<template>
  <DashboardLayout>
    <MainIndex />
    <div class="pb-16"></div>
  </DashboardLayout>
</template>

<script>
// @ is an alias to /src
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import MainIndex from '@/components/dashboard/transportationPrograms/MainIndex.vue';

export default {
  name: 'EmplyeesView',
  components: {
    DashboardLayout,
    MainIndex,
  },
};
</script>
